<script setup>
import { cn } from '@/lib/utils';
import { Primitive } from 'radix-vue';
import { buttonVariants } from '.';

const props = defineProps({
    variant: { type: null, required: false },
    size: { type: null, required: false },
    class: { type: null, required: false },
    asChild: { type: Boolean, required: false },
    as: { type: null, required: false, default: 'button' },
    authenticatebutton: { type: Boolean, default: false },
    processbutton: { type: Boolean, default: false },
    purplebutton: { type: Boolean, default: false },
});
</script>

<template>
    <Primitive :as="as" :as-child="asChild" :class="cn(buttonVariants({ variant, size }), props.class, { 'mt-4 w-full border border-black bg-black text-white transition-all duration-300 ease-in-out hover:bg-white hover:text-black dark:border-[#747474] dark:bg-[#26336E] dark:text-white dark:hover:bg-white dark:hover:text-black': authenticatebutton }, { 'border border-[#26336E] bg-[#26336E] transition-all duration-300 ease-in-out hover:bg-white hover:text-[#26336E] dark:border-[#fafafa] dark:bg-[#fafafa] dark:text-black dark:hover:bg-black dark:hover:text-white': processbutton })">
        <slot />
    </Primitive>
</template>
